export type CountryCode = {
    code: string;
    value: string;
}

export const CountryCodesPhone = [
    {code: 'be', value: '+32'},
    {code: 'nl', value: '+31'},
] as CountryCode[];

export const CountryCodesCountry = [
    {code: 'be', value: 'België'},
    {code: 'nl', value: 'Nederland'},
] as CountryCode[];